// extracted by mini-css-extract-plugin
module.exports = {"weekDays":"Weekdays_weekDays__20uzg"};